// extracted by mini-css-extract-plugin
export default {"drawer":"add-edit-coursework_drawer__P6x0T","footerWrapper":"add-edit-coursework_footerWrapper__zBpvc","footerBackButton":"add-edit-coursework_footerBackButton__PlFdn"};